<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                 {{year}} © MBQ <img src="assets/images/volumetricos.png" height="20" width="80">
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    eCSV 1.2.1
                </div>
            </div>
        </div>
    </div>
</footer>